module.exports = __webpack_public_path__ + "static/media/20-14.1a919d8b.mp3";